(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.header--top-center .mega-menu__list > li');

    menuItems.forEach(item => {
        item.addEventListener('click', function () {
            const innerList = this.querySelector('ul');

            // Get the current state of the menu
            const isActive = innerList.classList.contains('active');

            // Remove the active class from all inner <ul> elements
            menuItems.forEach(i => {
                const ul = i.querySelector('ul');
                if (ul) {
                    ul.style.height = 0; // Resetting height to 0
                    ul.classList.remove('active');
                }
            });

            // If it was not active, set its height to its scroll height
            if (!isActive) {
                innerList.style.height = innerList.scrollHeight + 'px'; // Set to its full height
                innerList.classList.add('active');
            }
            
            // After the transition, reset the height to auto
            innerList.addEventListener('transitionend', function() {
                if (innerList.classList.contains('active')) {
                    innerList.style.height = 'auto';
                }
            }, { once: true });
        });
    });
});
 (function() {
    var menuWrapper = document.querySelector('.mega_menu--links.main_menu--wrapper');
    var menuScroll = document.querySelector('.menu_scroll');

    if (menuWrapper) {
        var height = menuWrapper.offsetHeight;
        console.log('Height of main_menu--wrapper:', height);
        
        // Show the scroll button if the menu is taller than 399px
        if (height > 399) {
            menuScroll.classList.remove('hidden');
        }
    }

    // Add scroll event to menu_wrapper
    if (menuWrapper) {
        menuWrapper.addEventListener('scroll', function() {
            // Check if scrolled to the bottom
            if (menuWrapper.scrollTop + menuWrapper.clientHeight >= menuWrapper.scrollHeight) {
                menuScroll.classList.add('hidden'); // Hide button when at the bottom
            } else {
                menuScroll.classList.remove('hidden'); // Show button when not at the bottom
            }
        });
    }

    // Add click event to menu_scroll
    if (menuScroll) {
        menuScroll.addEventListener('click', function() {
            var button = this;

            // Check if the button has the active class
            if (button.classList.contains('hidden')) {
                // Check if scrolled to the bottom
                if (menuWrapper.scrollTop + menuWrapper.clientHeight >= menuWrapper.scrollHeight) {
                    button.classList.remove('hidden');
                    // Scroll back to the top smoothly
                    menuWrapper.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                } else {
                    // Scroll to the bottom smoothly
                    menuWrapper.scrollTo({
                        top: menuWrapper.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            } else {
                // Add hidden class and scroll to the bottom smoothly
                button.classList.add('hidden');
                menuWrapper.scrollTo({
                    top: menuWrapper.scrollHeight,
                    behavior: 'smooth'
                });
            }
        });
    }
})();

  } catch(e) { console.error(e); }
})();
})();
